import { render, staticRenderFns } from "./Passive.vue?vue&type=template&id=e46d4784"
import script from "./Passive.vue?vue&type=script&lang=js"
export * from "./Passive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports